import { Injectable } from '@angular/core';
import { State, Store } from '@ngrx/store';
import { map, shareReplay } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { UserProfile } from 'src/app/models/user-profile/user-profile';
import { getUserProfile } from '../../../shared/user-profile/user-profile.reducer';

@Injectable({ providedIn: 'root' })
export class GlobalHeaderQueries {
  readonly userProfile$: Observable<UserProfile>;
  readonly fullName$: Observable<string>;

  constructor(private readonly store: Store<State<any>>) {
    this.userProfile$ = this.store.pipe(
      getUserProfile,
      shareReplay(1),
    );

    this.fullName$ = this.userProfile$.pipe(
      map(v => v.getFullName()),
      shareReplay(1),
    );
  }
}
